<script>
  import { page } from '$app/stores';

  import contentMap from '$utils/ContentMapPage';
  import SetPageReferrer from '$utils/SetPageReferrer.svelte';

  let { data } = $props();

  let referrer = $state();
  let pageContent = $state();
  let pageTitle = $state();

  if ($page.status === 404) {
    referrer = data.errors['404'].referrer;
    pageContent = data.errors['404'].pageContent;
    pageTitle = data.errors['404'].social.pageTitle;
  } else {
    referrer = data.errors['500'].referrer;
    pageContent = data.errors['500'].pageContent;
    pageTitle = data.errors['500'].social.pageTitle;
  }
</script>

<svelte:head>
  <title>{pageTitle}</title>
</svelte:head>

<SetPageReferrer {referrer} />

{#each pageContent.imports as entry}
  {#if contentMap[entry.__typename]}
    {@const SvelteComponent = contentMap[entry.__typename]}
    <SvelteComponent {...entry} />
  {/if}
{/each}
